import { defineStore } from 'pinia';

import * as state from './predefined.state';
import * as getters from './predefined.getters';
import * as actions from './predefined.actions';

export const usePredefinedStore = defineStore('predefined', () => ({
  ...state,
  ...getters,
  ...actions
}));
